var _use, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 47"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Calendar_svg__a",
    fill: "currentColor",
    transform: "translate(5.59 13.16)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2459 129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Calendar_svg__c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Calendar_svg__b",
    fill: "#fff",
    transform: "translate(2459 -129)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Calendar_svg__c)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Calendar_svg__d",
    fill: "currentColor",
    transform: "translate(2459 -129)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2459 129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Calendar_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Calendar_svg__e",
    fill: "#fff",
    transform: "matrix(1 0 0 -1 2459 -117.72)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Calendar_svg__f)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Calendar_svg__g",
    fill: "currentColor",
    transform: "matrix(1 0 0 -1 2459 -117.72)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Calendar_svg__a",
    d: "m5.83 18.96 1.221-.816q.625 1.67 2.312 1.67.879 0 1.459-.607.59-.614.589-2.162 0-1.46-.694-1.986-.687-.528-1.609-.528h-.65v-1.274h.65q.782 0 1.406-.554.624-.562.624-1.74 0-1.152-.5-1.679-.503-.527-1.275-.527-1.424 0-2.048 1.67l-1.222-.809q1.24-2.223 3.279-2.223 1.45 0 2.355.975.914.976.914 2.593 0 2.162-1.784 2.927 2.057.58 2.057 3.155 0 2.022-1.002 3.076-1.002 1.046-2.54 1.046-2.303 0-3.542-2.206M18.75 21V9.39l-2.523 1.977-.677-1.142 3.367-2.637h1.336V21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Calendar_svg__b",
    d: "M0 0h41v47H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Calendar_svg__d",
    d: "M0 0v-2h-2v2zm41 0h2v-2h-2zm0 47v2h2v-2zM0 47h-2v2h2zM0 2h41v-4H0zm39-2v47h4V0zm2 45H0v4h41zM2 47V0h-4v47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Calendar_svg__e",
    d: "M0 0h41v11.28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Calendar_svg__g",
    d: "M0 0v-2h-2v2zm41 0h2v-2h-2zm0 11.28v2h2v-2zm-41 0h-2v2h2zM0 2h41v-4H0zm39-2v11.28h4V0zm2 9.28H0v4h41zm-39 2V0h-4v11.28z"
  }))));
};
export default SvgCalendar;